// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import { imagePath } from 'frontend_core/dist/helpers/image'

const Title = styled.p`
  font-size: ${fontSize.small_3}px;
  color: ${Colors.black};
  font-weight: bold;
`
const Content = styled.div`
  display: table;
  width: 100%;
  margin-top: ${spacing.small_3}px;
`
const Thumbnail = styled.div`
  display: table-cell;
  width: 90px;
  height: 90px;
  background-image: url(${props =>
    props.src || imagePath('common/noimage_search.png')});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: ${Colors.grayE};
  overflow: hidden;
  border-radius: ${borderRadius}px;
`
const Text = styled.p`
  display: table-cell;
  padding-left: ${spacing.small_3}px;
  font-size: ${fontSize.small_3}px;
  color: ${Colors.black};
  line-height: 1.285;
`
const Link = styled.a`
  text-decoration: none;
  color: ${Colors.black};
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`

export type PropTypes = {
  src?: ?string,
  text: string,
}

export default function MediaSpace(props: PropTypes) {
  return (
    <div>
      <Title>{i18n.t('page.dashboard.reservation.spaceName')}</Title>
      <Content>
        <Link href={props.spaceUrl} target="_blank">
          <Thumbnail src={props.src} alt={props.text} />
          <Text>{props.text}</Text>
        </Link>
      </Content>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/MediaSpace/index.jsx